// Components
import { CapabilityCard } from '../CapabilityCard/CapabilityCard';
import {
  FileText,
  Layers,
  Repeat,
  Search,
  PlusSquare,
  BarChart2,
  MousePointer,
  Edit3,
  Typography,
} from '@archieai/ui';

// Capability data
const CAPABILITIES = [
  {
    icon: <FileText />,
    title: 'Read & Process',
    description:
      'Extract information from documents in any format (PDFs, Excel, images, emails) regardless of structure or quality.',
  },
  {
    icon: <Layers />,
    title: 'Extract & Structure',
    description:
      'Transform unstructured information into organized, usable data formats ready for analysis or system entry.',
  },
  {
    icon: <Layers />,
    title: 'Learn & Remember',
    description:
      'Understand and retain firm-specific processes, client preferences, and institutional knowledge to provide consistent, contextual support.',
  },
  {
    icon: <Repeat />,
    title: 'Compare & Reconcile',
    description:
      'Find corresponding items across different data sources and identify matches, discrepancies, and missing items.',
  },
  {
    icon: <Layers />,
    title: 'Reason & Explain',
    description:
      'Apply accounting knowledge and business logic to provide context, interpretation, explanations, and recommendations based on data and analysis.',
  },
  {
    icon: <BarChart2 />,
    title: 'Analyze & Detect',
    description:
      'Identify patterns, trends, anomalies, and exceptions across financial data using statistical analysis and accounting knowledge.',
  },
  {
    icon: <Search />,
    title: 'Search & Retrieve',
    description:
      'Find specific information across thousands of documents and systems instantly, understanding context and intent.',
  },
  {
    icon: <PlusSquare />,
    title: 'Generate & Create',
    description:
      'Produce reports, financial statements, compliance documents, and client deliverables from structured data and analysis.',
  },
  {
    icon: <MousePointer />,
    title: 'Navigate & Execute',
    description:
      'Control web interfaces and systems to perform tasks directly, like a human clicking through websites and applications.',
  },
  {
    icon: <Layers />,
    title: 'Calculate & Compute',
    description:
      'Perform financial calculations, aggregations, and mathematical operations with accuracy and built-in accounting logic.',
  },
  {
    icon: <Edit3 />,
    title: 'Draft & Communicate',
    description:
      'Write clear, professional communications in appropriate formats and tones for different audiences and purposes.',
  },
];

export const CapabilitiesSection = () => {
  return (
    <section
      id="capabilities"
      className="flex flex-col items-center gap-[var(--spacing-24)] px-[var(--spacing-24)] py-[var(--spacing-64)] w-full max-w-[1224px] max-md:px-[var(--spacing-16)] max-md:py-[var(--spacing-48)]"
    >
      <Typography as="h2" variant="h1" className="text-blue-1000 text-center">
        What Archie Can Do
      </Typography>

      {/* Flex container with wrap - centers incomplete rows automatically */}
      <div className="flex flex-wrap justify-center gap-[var(--spacing-24)] w-full max-w-[1016px]">
        {CAPABILITIES.map((capability) => (
          <CapabilityCard
            key={capability.title}
            icon={capability.icon}
            title={capability.title}
            description={capability.description}
            className="w-[calc(33.333%-16px)] max-lg:w-[calc(50%-12px)] max-md:w-full"
          />
        ))}
      </div>
    </section>
  );
};
